import { NextPage } from "next"
import { apiClient } from "../../lib";
import { API_ENDPOINTS, API_SERVICE_URLS } from "../../clients/configs";
import { AppHeader } from "../../components/Layout/Header";
import { AppFooter } from "../../components/Layout/Footer";
import { useTranslator } from "../../hooks/useTranslator";
import { AppErrorBoundary } from "../../components/AppErrorBoundary";
import { GoogleMap } from "../../components/GoogleMap";
interface PageProps {
    data: any[]
}
const CentersPage: NextPage<PageProps> = ({ data }) => {

    const { __T } = useTranslator();
    return (<>
        <AppHeader isFixed={false} />
        <div className="container pt-4 my-4 mx-auto">
            <h2 className="text-3xl mb-3">{__T('Service Centers')}</h2>
            <div className='relative h-[500px]'>
                <AppErrorBoundary>
                    <GoogleMap
                        showMarker={true}
                        showPlacesAutoComplete={false}
                        apiKey={'AIzaSyBSOV0hqG_wkzf76NZ7kcvVDhP4xJxqnAg'}
                        // onLatLngChanged={handleLatLangChange}
                        center={{
                            lat: 24.81,
                            lng: 46.88,
                        }}
                        markerList={data}
                        libraries={['places']}
                        defaultToMyLocation={true}
                    />
                </AppErrorBoundary>
            </div>

        </div>
        <AppFooter />
    </>)
}
export default CentersPage;
export const getServerSideProps: any = async ({
    req,
    res,
    query,
}: {
    req: any;
    res: any;
    query: any;
}) => {
    const catalogApi = apiClient(API_SERVICE_URLS.USER, req, res);
    let data = [];
    let err: any;
    const id = query?.params?.id;
    try {
        const [supplierData] = await Promise.allSettled([
            catalogApi.get(API_ENDPOINTS.getAllSuppliers),
        ]);

        data =
            supplierData?.status === 'fulfilled'
                ? supplierData?.value?.data
                : [];
    } catch (error) {
        err = error
        data = [];
    }
    return { props: { data, } };
}